import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {Input, Button, Checkbox} from "antd";

const InputProps = {
    ...Input.defaultProps, ...Input.propTypes, onChange: () => {
    }
}

/**
 * Input输入框
 */
class confirmBox extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            value: ""
        };

        this.suffixDomRef = React.createRef();
    }

    componentDidMount() {
        const observer = new ResizeObserver((e, o) => {
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);

        if (this.suffixDomRef.current) {
            observer.observe(this.suffixDomRef.current);
        }
        this.updateValue();
    }

    componentWillUnmount() {
        this.setState = () => {
        }
    }

    static getDerivedStateFromProps(props, state) {
        // 判断props中的属性
        if (props.fieldProps && state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(confirmBox.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if (Array.isArray(props.fieldProps?.extra) && !props.fieldProps?.extra.includes(fieldKey)) {
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }

            return {...state, fieldProps: {...newProps}}
        }
        return state
    }


    renderSuffixButton() {
        const {buttonProps = {}} = this.props.fieldProps;
        return (
            <>
                <Button {...buttonProps}>{buttonProps?.name}</Button>
            </>
        )
    }

    render() {
        const {prefixLayout, suffixLayout, style = {}, suffixButton, confirmContent, required} = this.props.fieldProps;
        const {fieldProps, suffixWidth} = this.state;
        return (
            <>
                <div style={{display: "flex", alignItems: "baseline"}}>
                    <div className="rmt-input-content-layout" style={style}>
                        <Checkbox id={this.props.name} checked={!!this.state.value}/>
                    </div>
                    <div className="rmt-input-suffix-layout" ref={this.suffixDomRef}
                         style={{
                             maxWidth: "100%",
                             flexShrink: 1,
                             lineHeight: "20px",
                             display: '-webkit-box',
                             marginLeft: "5px",
                         }}>{confirmContent}</div>
                    {
                        (!!suffixButton && !suffixLayout) && <div className="rmt-input-suffix-layout"
                                                                  ref={this.suffixDomRef}>{this.renderSuffixButton()}</div>
                    }
                </div>
                <style>
                    {
                        `div[data-name = '${this.props.name}'] .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth > 0 ? suffixWidth : 35}px);
                        }`
                    }
                </style>
            </>
        )
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        } else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}

export default confirmBox;

confirmBox.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

confirmBox.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
    setFiledValidateStatus: () => {
    }
}